import type { CardInstance, CardLookup, LoadEffect } from "../types/index.js";
import { LOAD_FLAVORS } from "./loadFlavors.js";

type WorkerGroup = { name: string; count: number };

function workerGroups(
  hand: readonly CardInstance[],
  lookup: CardLookup,
  healersOnly = false,
): WorkerGroup[] {
  const map = new Map<string, WorkerGroup>();
  for (const card of hand) {
    const def = lookup(card.cardId);
    if (def?.type !== "worker") continue;
    if (healersOnly && !def.heal) continue;
    const existing = map.get(def.id);
    if (existing) existing.count += 1;
    else map.set(def.id, { name: def.name, count: 1 });
  }
  return [...map.values()];
}

function formatWorkerWho(groups: WorkerGroup[]): string {
  return groups.length === 1
    ? `${groups[0].name} ${groups[0].count}人が`
    : "手札の労働者が";
}

export function formatProgressMessage(
  gain: number,
): string {
  if (gain <= 0) return "";
  const praise = gain <= 2
    ? "思うように進捗が出なかった。"
    : gain <= 4
      ? "まずまずの進捗だ。"
      : gain <= 9
        ? "いい進捗だ！"
        : "凄まじい進捗！";
  return `${praise} このターンの進捗は +${gain} だった。`;
}

export function formatHealMessage(
  amount: number,
  hand: readonly CardInstance[],
  lookup: CardLookup,
): string {
  if (amount <= 0) return "";
  return `${formatWorkerWho(workerGroups(hand, lookup, true))}、疲労を ${amount} 減らした。`;
}

export function formatLoadMessage(load: LoadEffect): string {
  return LOAD_FLAVORS[load.id] ?? "";
}

export function formatDeadlineMessage(from: number, to: number): string {
  return `このフェーズを消費した。残りは ${from} → ${to}。`;
}

export const OVERDUE_MESSAGE = "期限までに終わらなかった。疲労 +5。";
export const SUCCESS_MESSAGE = "";
export const FAILURE_MESSAGE = "";
export const GAMEOVER_MESSAGE = "全社疲労が限界に達した。";
